import { MarcacaoConsulta } from "../marcacao/marcacao-consulta/marcacao-consulta";
import { RespostaMarcacaoDTO } from "./resposta-marcacao-dto";

export class RespostaMarcacaoConsultaDTO extends RespostaMarcacaoDTO {

    marcacaoConsulta: MarcacaoConsulta;

    constructor(resposta: string, marcacaoConsulta: MarcacaoConsulta) {
        super(resposta);

        this.marcacaoConsulta = marcacaoConsulta;
    }
}
